// RB-MY01-PalmGarden.web/src/components/AddPlantFormWrapper.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../services/api';
import AddPlantForm from './AddPlantForm';

const AddPlantFormWrapper: React.FC = () => {
  const navigate = useNavigate();
  const api = useApi();

  const handleAddPlant = async (plantData: any) => {
    try {
      // Convert the form data to the API format
      const apiPlantData = {
        name: plantData.name,
        type: plantData.species,
        description: plantData.description || '',
        careInstructions: plantData.careInstructions || '',
        wateringFrequency: 7, // Default value
        lightRequirement: 'Medium', // Default value
        imageUrl: plantData.images?.[0] || '',
        published: plantData.published || false
      };

      await api.createPlant(apiPlantData);
      navigate('/admin/plants');
    } catch (error) {
      console.error('Error creating plant:', error);
      throw error;
    }
  };

  const handleCancel = () => {
    navigate('/admin/plants');
  };

  return (
    <AddPlantForm
      onAddPlant={handleAddPlant}
      onCancel={handleCancel}
    />
  );
};

export default AddPlantFormWrapper; 